import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('ReportMyInvoice', ReportData);

    ReportData.$inject = [];

    /* @ngInject */
    function ReportData() {
        Report.prototype = {
            build: build
        };

        function Report(reportData) {
            this.build(reportData);
        }

        return Report;

        function build(reportData) {
            this.status = reportData.status || null;
            this.message = reportData.message || null;
        }
    }
})();
